import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-vision-plan',
    templateUrl: './vision-plan.component.html',
    styleUrls: ['./vision-plan.component.scss']
})
export class VisionPlanComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

}
